module.exports = __webpack_public_path__ + "img/pic06@2x.35ac6352.png";